import * as reactRouterDom from "react-router-dom";
import { AuthProvider } from "./providers/AuthProvider";
import AppRoutes from "./routes/AppRoutes";

export default function App() {
    return (
        <AuthProvider>
            <reactRouterDom.BrowserRouter>
                <AppRoutes />
            </reactRouterDom.BrowserRouter>
        </AuthProvider>
    );
}
